import React, { useEffect, useState } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Alert, Button, Modal, ModalBody,
  ModalHeader, ModalFooter,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { get } from '../../helpers/api_helper';
import BaseGrid from '../Common/BaseGrid';

function SJBC(props) {
  // eslint-disable-next-line no-unused-vars
  const { t, listing } = props;
  const [storeInfo, setStoreInfo] = useState(null);
  const [productInfo, setProductInfo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [pushing, setPushing] = useState(false);
  const [error, setError] = useState(false);
  const [channelLog, setChannelLog] = useState(null);
  const [remoteId, setRemoteId] = useState(props.remoteId);
  const [modalOpen, setModalOpen] = useState(false);

  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const fetchData = async () => {
    setLoading(true);

    try {
      const info = await get('/api/bc/info');
      setStoreInfo(info);

      if (remoteId !== null) {
        const pinfo = await get(`/api/bc/product/${remoteId}`);
        const log = await get(`/api/bc/channel-logs?f=remote_id=${remoteId}&page=1&sort=id&dir=desc&per=30&`);

        setProductInfo(pinfo);

        if (log.results.length > 0) {
          setChannelLog(log.results[0]);
        }
      }
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (remoteId !== null) {
      fetchData();
    }
  }, [remoteId]);

  const pushSync = async () => {
    setPushing(true);

    try {
      await get(`/api/bc/push/${remoteId}`);

      fetchData();
    } catch (e) {
      toastr.error(e.message);
      if (e.response && e.response.data && e.response.data.error) {
        toastr.error(e.response.data.error);
      }
    } finally {
      setPushing(false);
    }
  };

  const createRemote = async () => {
    setPushing(true);

    try {
      const response = await get(`/api/bc/create/${listing.id}`);

      setRemoteId(response.remote_id);
    } catch (e) {
      toastr.error(e.message);
      if (e.response && e.response.data && e.response.data.error) {
        toastr.error(e.response.data.error);
      }
    } finally {
      setPushing(false);
    }
  };

  const jsx = (
    <div>
      <Alert color="danger" className="mb-3" isOpen={error !== false}>
        {error}
      </Alert>
      {remoteId !== null && (
        <>
          {storeInfo !== null && (
            <span>
              <span className="mdi mdi-earth" />
              &nbsp;
              {storeInfo.domain}
            </span>
          )}
          {storeInfo === null && (
            <span>
              <span className="mdi mdi-earth" />
              &nbsp;
              ?
            </span>
          )}
          <br />
          <br />
          {productInfo !== null && (
            <a href={`${storeInfo.secure_url}${productInfo.data.custom_url.url}`} target="_blank" style={{ fontSize: '11px' }} rel="noreferrer">
              <span className="mdi mdi-application-export" />
              &nbsp;
              {`${storeInfo.secure_url}${productInfo.data.custom_url.url}`}
            </a>
          )}
          {productInfo === null && (
            <span>
              <span className="mdi mdi-application-export" />
              &nbsp;
              ?
            </span>
          )}
          <br />
          {storeInfo !== null && (
            <a href={`${storeInfo.control_panel_base_url}/manage/products/edit/${remoteId}`} target="_blank" style={{ fontSize: '11px' }} rel="noreferrer">
              <span className="mdi mdi-account-tie" />
              &nbsp;
              {t('Manage on ShopJimmy.com')}
            </a>
          )}
          {(storeInfo === null) && (
            <span>
              <span className="mdi mdi-account-tie" />
              &nbsp;
              ?
            </span>
          )}

          <div className={`mt-3 mb-3 ${loading ? 'text-muted' : ''}`}>
            <span className="mdi mdi-information-outline" />
            &nbsp;
            {t('Remote ID:')}
            &nbsp;
            {remoteId}
            <br />
            <span className="mdi mdi-information-outline" />
            &nbsp;
            <span>
              {t('Last Successful Update (according to BC):')}
            </span>
            &nbsp;
            {productInfo !== null ? new Date(productInfo.data.date_modified).toLocaleString('en-US', {
              weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric',
            }) : '?'}
            <br />
            <span className="mdi mdi-information-outline" />
            &nbsp;
            <span>
              {t('Qty Available on BC:')}
            </span>
            &nbsp;
            {productInfo !== null ? productInfo.data.inventory_level : '?'}
            <br />
            <br />
            <span className="mdi mdi-information-outline" />
            &nbsp;
            {t('Last Update Attempt:')}
            &nbsp;
            {channelLog !== null ? new Date(channelLog.attempted_at).toLocaleString('en-US', {
              weekday: 'short', year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric',
            }) : '?'}
          </div>
        </>
      )}

      <div>
        <div className="hstack gap-2">
          {remoteId !== null && (
            <>
              <Button color="primary" title={t('Push Sync')} onClick={pushSync}>
                <span className="mdi mdi-sync" />
                &nbsp;
                {pushing !== false ? t('Pushing...') : t('Push Sync')}
              </Button>

              <Button color="info" title={t('View Logs')} onClick={() => { setModalOpen(true); }} className="btn-soft-info text-dark">
                <span className="mdi mdi-eye" />
                &nbsp;
                {t('View Logs')}
              </Button>
            </>
          )}

          {remoteId === null && (
            <Button color="success" title={t('Create Remote')} className="btn-soft-success text-dark" onClick={createRemote}>
              <span className="mdi mdi-sync" />
              &nbsp;
              {pushing !== false ? t('Creating...') : t('Create Remote')}
            </Button>
          )}
        </div>

        {remoteId !== null && (
        <div className="mt-4">
          <h6>{t('Metafields Queue')}</h6>
          <BaseGrid
            url="/api/bc/metafields"
            filters={`listing_id=${listing.id}`}
            shouldPaginate={false}
            className="table-sm"
            config={
            {
              columns: {
                namespace: { label: props.t('Namespace'), sort: false },
                key: { label: props.t('Key'), sort: false },
                value: {
                  label: props.t('Value'),
                  sort: false,
                  format: (x) => {
                    const prs = JSON.parse(x);
                    if (prs !== false) {
                      if (Array.isArray(prs)) {
                        return prs.join(', ');
                      }
                    }

                    return x;
                  },
                },
              },
              pagination: {
                sort: 'id',
                direction: 'asc',
                perPage: 5,
              },
            }
            }
          />
        </div>
        )}
      </div>

      <Modal
        size="lg"
        isOpen={modalOpen}
      >
        <ModalHeader>
          <h5
            className="modal-title mt-0"
            id="myLargeModalLabel"
          >
            {t('Channel Logs')}
          </h5>
          <button
            onClick={() => setModalOpen(false)}
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </ModalHeader>
        <ModalBody>
          <BaseGrid
            url="/api/bc/channel-logs"
            filters={`remote_id=${remoteId}`}
            config={
            {
              columns: {
                attempted_at: {
                  label: props.t('Attempted At'),
                  date: {
                    format: (date) => (new Date(date).toLocaleString()),
                  },
                },
                message: {
                  label: props.t('Message'),
                },
                result: {
                  label: props.t('Result'),
                  format: (v, x) => (x.inventory_synced_at || x.data_synced_at ? 'Success' : 'Failed'),
                },
              },
              pagination: {
                sort: 'id',
                direction: 'desc',
                perPage: 5,
              },
            }
            }
          />
        </ModalBody>
        <ModalFooter>
          <button
            type="button"
            onClick={() => setModalOpen(false)}
            className="btn btn-soft-dark"
            data-dismiss="modal"
          >
            {t('Close')}
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );

  return jsx;
}

SJBC.defaultProps = {
  t: (x) => (x),
  remoteId: null,
};

SJBC.propTypes = {
  t: PropTypes.any,
  remoteId: PropTypes.any,
  listing: PropTypes.object.isRequired,
};

export default connect(() => ({

}), {})(withTranslation()(SJBC));
